import { FooterBarLink, List, ListItemInteractive, Modal, SystemIcon, Typography } from '@volvo/vcdk-react';
import { useState } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';

import { withComponentErrorBoundary } from '@/components/ComponentErrorBoundary';
import { languageKey } from '@/config/EnviromentConfig';

const ChangeLanguageModal: React.FC = () => {
  const { i18n, t } = useTranslation();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const changeLanguage = (lng: string) => {
    localStorage.setItem(languageKey, lng);
    i18n.changeLanguage(lng);
    document.documentElement.setAttribute('lang', lng);
  };

  return (
    <div>
      <FooterBarLink
        onClick={(e) => {
          e.preventDefault();
          setIsOpen(true);
        }}
      >
        <SystemIcon icon="globe" className="mr-4" />
        {t(($) => $.components.language_selector[i18n.language as keyof typeof $.components.language_selector])}
      </FooterBarLink>
      {isOpen &&
        createPortal(
          <Modal open={isOpen} onClose={() => setIsOpen(false)} width={600} maxWidth="90%">
            <span slot="header">Select language</span>
            <div className="mb-6">
              <Typography>Choose preferred language and website will be translated.</Typography>
            </div>
            <List>
              <ListItemInteractive
                onClick={() => {
                  setIsOpen(false);
                  changeLanguage('en');
                }}
              >
                <Typography>English</Typography>
                <SystemIcon icon="arrow-right" />
              </ListItemInteractive>
              <ListItemInteractive
                onClick={() => {
                  setIsOpen(false);
                  changeLanguage('sv');
                }}
              >
                <Typography>Svenska</Typography>
                <SystemIcon icon="arrow-right" />
              </ListItemInteractive>
              <ListItemInteractive
                onClick={() => {
                  setIsOpen(false);
                  changeLanguage('de');
                }}
              >
                <Typography>Deutsch</Typography>
                <SystemIcon icon="arrow-right" />
              </ListItemInteractive>
              <ListItemInteractive
                onClick={() => {
                  setIsOpen(false);
                  changeLanguage('fr');
                }}
              >
                <Typography>Français</Typography>
                <SystemIcon icon="arrow-right" />
              </ListItemInteractive>
              <ListItemInteractive
                onClick={() => {
                  setIsOpen(false);
                  changeLanguage('nl');
                }}
              >
                <Typography>Nederlands</Typography>
                <SystemIcon icon="arrow-right" />
              </ListItemInteractive>
              <ListItemInteractive
                onClick={() => {
                  setIsOpen(false);
                  changeLanguage('it');
                }}
              >
                <Typography>Italiano</Typography>
                <SystemIcon icon="arrow-right" />
              </ListItemInteractive>
              <ListItemInteractive
                onClick={() => {
                  setIsOpen(false);
                  changeLanguage('pt');
                }}
              >
                <Typography>Português (Brasil)</Typography>
                <SystemIcon icon="arrow-right" />
              </ListItemInteractive>
            </List>
            <span slot="modalFooter"></span>
          </Modal>,
          document.body
        )}
    </div>
  );
};

export default withComponentErrorBoundary(ChangeLanguageModal);
